export const LISTINGLAYOUT_COMPONENT = 'Listing layout';
export const FILTER_SECTION = 'filter section';
export const SMARTLIST_SECTION = 'smart list section';
export const FILTEREEDLIST_SECTION = 'filtered list section';
